import router from '@/router'
import BaseErrorHandler from '@/apis/errorHandler/handler/BaseErrorHandler'
import  AlertTypeEnum from '@/apis/errorHandler/AlertTypeEnum'
export default class VantisUnauthorizedAccessException extends BaseErrorHandler {
    protected AlertType: AlertTypeEnum = AlertTypeEnum.ERROR;
    protected Code: string = "VantisUnauthorizedAccessException";
    constructor() {
        super("","未授权!",undefined,true,false);
    }
    customizeAction(): void {
        router.replace({name: 'AccessDenied'})
    }
}
